import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="32"
        viewBox="0 0 32 32"
        width="32"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M5 25V12.0184C5 11.3786 5.30617 10.7773 5.82366 10.401L14.8237 3.85552C15.525 3.34549 16.475 3.34549 17.1763 3.85552L26.1763 10.401C26.6938 10.7773 27 11.3786 27 12.0184V25C27 26.1046 26.1046 27 25 27H7C5.89543 27 5 26.1046 5 25Z"
            fill="#F6F6F6"
            stroke="#818181"
            strokeWidth="2"
        />
        <path
            d="M12 19V27H20V19C20 17.8954 19.1046 17 18 17H14C12.8954 17 12 17.8954 12 19Z"
            fill="#FB913C"
            stroke="#C2410C"
            strokeWidth="2"
        />
        <path
            d="M3 12L14.8616 3.78814C15.5465 3.31398 16.4535 3.31398 17.1384 3.78814L29 12"
            stroke="#B73F34"
            strokeLinecap="round"
            strokeWidth="3"
        />
    </svg>
);

export default Icon;
